import React from "react";
import {useReservationTicketOptions} from "utils/hooks/useReservationTicketOptions";
import {ReservationDriverAssignOption} from "types/enums/specific/ReservationDriverAssignOption";
import AccessTicketDriversAssignUserButton from "pages/Front/Booking/BookingLogin/components/ReservationDetailComponents/AccessTicketDriversAssignUserButton";
import FeatherIcon from "components/FeatherIcon";
import clsx from "clsx";

const AccessTicketDriversAssignOption = (props: {
    option: ReservationDriverAssignOption;
    isLoading: number | null;
    onClick: () => void;
    subLabel?: string | null;
    className?: string;
}) => {
    const {getOption} = useReservationTicketOptions();

    const generatedOption = getOption(props.option);

    return (
        <AccessTicketDriversAssignUserButton
            className={clsx("AccessTicketDriversAssignOption", props.option, props.className)}
            onClick={props.onClick}
            backIcon={<FeatherIcon name={"arrow-right-circle"} className={"size-[20px] md:size-[30px]"} strokeWidth={2} />}
            frontIcon={<div className={"text-gray-300"}>{generatedOption.icon}</div>}
            isLoading={false}
        >
            <div className={"flex flex-col items-start grow font-medium text-left py-3"}>
                <span className={""}>{generatedOption.label}</span>
                {props.subLabel && <span className={"font-light text-xxs md:text-xs leading-[1] text-arbo-blue"}>{props.subLabel}</span>}
            </div>
        </AccessTicketDriversAssignUserButton>
    );
};

export default AccessTicketDriversAssignOption;
